import { Check, Target, Bot, GraduationCap } from "lucide-react";

/**
 * Seção de Solução - Apresentação do método completo
 * Mostra os 3 pilares: Tráfego Pago + IA + Treinamento
 */
export function Solution() {
    const pillars = [
        {
            icon: Target,
            title: "Tráfego Pago Estratégico",
            description:
                "Campanhas otimizadas para atrair pacientes qualificados, não apenas cliques. Investimento direcionado para quem realmente precisa dos seus serviços.",
        },
        {
            icon: Bot,
            title: "Atendimento com IA",
            description:
                "Inteligência artificial que atende, qualifica e agenda pacientes 24 horas por dia, 7 dias por semana, sem perder nenhuma oportunidade.",
        },
        {
            icon: GraduationCap,
            title: "Treinamento Comercial",
            description:
                "Capacitação completa da sua equipe para converter leads em consultas agendadas e fidelizar pacientes.",
        },
    ];

    return (
        <section className="py-24 bg-slate-950 relative overflow-hidden">
            {/* Background grid */}
            <div className="absolute inset-0 bg-grid opacity-20" />

            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <span className="inline-flex items-center gap-2 text-brand-400 font-semibold mb-4">
                        <Check className="w-5 h-5" />
                        A SOLUÇÃO
                    </span>
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
                        O método que transforma clínicas em{" "}
                        <span className="text-brand-400 drop-shadow-[0_0_15px_rgba(74,222,128,0.5)]">
                            máquinas de agendamento
                        </span>
                    </h2>
                    <p className="text-lg text-slate-400 max-w-3xl mx-auto">
                        Combinamos três pilares essenciais para garantir que sua agenda
                        esteja sempre cheia de pacientes qualificados.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                    {pillars.map((pillar, index) => (
                        <div
                            key={index}
                            className="bg-slate-900/50 backdrop-blur-sm rounded-2xl p-8 card-neon border border-brand-500/20"
                        >
                            <div className="w-14 h-14 bg-brand-600 rounded-xl flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(34,197,94,0.4)]">
                                <pillar.icon className="w-7 h-7 text-white" />
                            </div>
                            <h3 className="text-xl font-bold text-white mb-3">
                                {pillar.title}
                            </h3>
                            <p className="text-slate-400">{pillar.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
